import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { CHANGES, hasUnseenChanges, markChangesSeen } from "./whatsNewChanges";

const LATEST_COUNT = 5;

export const ChangeList = ({ changes, showDate = true }) => (
  <ul className="list-unstyled mb-0">
    {changes.map((change) => (
      <li key={change.text} className="d-flex gap-3 mb-2 small">
        {showDate && <span className="text-body-secondary text-nowrap">{change.date}</span>}
        <span>{change.text}</span>
      </li>
    ))}
  </ul>
);

// "What's new" button with a dot until the latest change has been seen; the modal shows the latest few
export default function WhatsNewButton() {
  const [show, setShow] = useState(false);
  const [unseen, setUnseen] = useState(false);

  useEffect(() => {
    setUnseen(hasUnseenChanges());
  }, []);

  const open = () => {
    setShow(true);
    setUnseen(false);
    markChangesSeen();
  };

  return (
    <>
      <Button variant="outline-secondary" size="sm" className="position-relative" onClick={open}>
        What's new
        {unseen && <span className="whats-new-dot" aria-label="New changes" />}
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>What's new</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-start">
          <ChangeList changes={CHANGES.slice(0, LATEST_COUNT)} />
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          {CHANGES.length > LATEST_COUNT ? (
            <Link to="/whats-new" className="small" onClick={() => setShow(false)}>
              See all changes ({CHANGES.length})
            </Link>
          ) : (
            <span />
          )}
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
